import { Row, Col, Collapse } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import styles from "./HomePage.module.css";
import "./HomePage.css";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import { QuestionBlock, QuestionCard } from "./QuestionsModule";
import MinorHeader from "./MinorHeader";

function ProsSmallCard({ header, description, gifSrc, squareText }) {
  const descriptionClass = `mt-1 mt-lg-2`;
  const divClass = `${styles.card} `;
  const { s, toggleTheme } = useTheme();

  return (
    <Col>
      <div
        className={`${divClass} ${styles.smallCardStructure} `}
        style={s.cardBg}
      >
        <Row className="g-0">
          <Col
            xs={12}
            md={8}
            // style={{ paddingTop: "20px", paddingLeft: "33px" }}
            className={`d-flex flex-column justify-content-center`}
            // className="d-flex flex-column justify-content-center pt-3 pt-lg-4 ps-4 ps-lg-5"
          >
            <h4
              className={styles.cardHeader}
              style={{ ...s.cardHeader, fontFamily: "Gilroy-semibold" }}
            >
              {header}{" "}
              <span style={{ backgroundColor: s.squareTextBg }}>
                {squareText}
              </span>
            </h4>
            <p className={descriptionClass} style={s.cardDescr}>
              {description}
            </p>
          </Col>
          <Col
            xs={12}
            md={4}
            className="d-flex align-items-center justify-content-center"
          >
            <img
              draggable="false"
              src={gifSrc}
              alt="GIF"
              className={styles.prosSmallGif}
            />
          </Col>
        </Row>
      </div>
    </Col>
  );
}
function ProsBigCard({ header, description, gifSrc1, gifSrc2, style }) {
  const { s, toggleTheme } = useTheme();

  const divClass = `${styles.card}`;
  const headingPart = (
    <Col
      xs={12}
      //   style={{
      //     paddingTop: "20px",
      //     paddingLeft: "33px",
      //     paddingRight: "20px",
      //   }}
      // className="pt-3 pt-lg-4 ps-4 ps-lg-5 pe-4 pe-lg-5 "
    >
      <h4 style={{ ...s.cardHeader, fontFamily: "Gilroy-semibold" }}>
        {header}
      </h4>
      <p style={s.cardDescr}>{description}</p>
    </Col>
  );
  const gifPart = (
    <Col xs={12}>
      <Row className="g-0">
        <Col
          className="d-flex align-items-center justify-content-center"
          xs={5}
        >
          <img
            draggable="false"
            src={gifSrc1}
            alt="GIF"
            className={styles.prosSmallGif}
          />
        </Col>
        <Col
          className="d-flex align-items-center justify-content-center"
          xs={2}
        >
          {/* <img
            src={"/img/cardArrowsDark.png"}
            alt="IMG"
            className={styles.arrowsImg}
          /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            className={styles.arrowsImg}
          >
            <rect
              x="0.5"
              y="0.5"
              width="51"
              height="51"
              rx="15.5"
              fill={s.prosBigArrowBg}
            />
            <rect
              x="0.5"
              y="0.5"
              width="51"
              height="51"
              rx="15.5"
              stroke={s.prosBigArrowStroke}
            />
            <path
              d="M32.2222 32.4V26L40 34L32.2222 42V35.6H13.5556V32.4H32.2222ZM19.7778 10V16.3984L38.4444 16.4V19.6H19.7778V26L12 18L19.7778 10Z"
              fill="url(#paint0_linear_3315_464)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_3315_464"
                x1="12"
                y1="17.5"
                x2="40"
                y2="34"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#C5C5C5" />
                <stop offset="1" stopColor="#949494" />
              </linearGradient>
            </defs>
          </svg>
        </Col>
        <Col
          className="d-flex align-items-center justify-content-center"
          xs={5}
        >
          <img
            draggable="false"
            src={gifSrc2}
            alt="GIF"
            className={styles.prosSmallGif}
          />
        </Col>
      </Row>
    </Col>
  );
  return (
    <Col>
      <div
        className={`${divClass} ${styles.prosBigCardStructure} h-100`}
        style={s.cardBg}
      >
        <Row className="g-0">
          {style === 1 ? (
            <>
              {headingPart}
              <div className="mt-3"></div>
              {gifPart}
            </>
          ) : (
            <>
              {gifPart}
              <div className="mt-3"></div>
              {headingPart}
            </>
          )}
        </Row>
      </div>
    </Col>
  );
}

function ProsModule() {
  const { lang, changeLang, t } = useLang();
  return (
    <Row xs={1} lg={2} className="g-4 mt-2 mt-lg-4 align-items-stretch">
      <ProsSmallCard
        header={t("prosCard1Header1")}
        description={t("prosCard1Descr1")}
        gifSrc={"/img/fire.gif"}
      />
      <ProsSmallCard
        header={t("prosCard1Header2")}
        description={t("prosCard1Descr2")}
        gifSrc={"/img/rocket.gif"}
        squareText={"100%"}
      />
      <ProsBigCard
        header={t("prosCard1Header3")}
        description={t("prosCard1Descr3")}
        gifSrc1={"/img/programmer.gif"}
        gifSrc2={"/img/phone.gif"}
        style={1}
      />
      <ProsBigCard
        header={t("prosCard1Header4")}
        description={t("prosCard1Descr4")}
        gifSrc1={"/img/key.gif"}
        gifSrc2={"/img/graph.gif"}
        style={2}
      />
    </Row>
  );
}

function Pros2Card({ header, description, picSrc, children }) {
  const { s, toggleTheme } = useTheme();

  const descriptionClass = `${styles.cardDescr}`;
  const headerClass = `${styles.cardHeader} m-0`;
  const divClass = `${styles.card} h-100 ${styles.pros2CardStructure}`;
  return (
    <Col>
      <div
        className={divClass}
        style={s.cardBg}
        //   style={{ paddingBottom: "7px" }}
      >
        <Row>
          <Col xs={12}>
            <div className="d-flex align-items-center gap-3">
              <div>
                <div className="panel-container" style={s.card2IconBG}>
                  {children}
                </div>
              </div>
              {/* <img src={picSrc} alt="IMG" className={styles.prosSmallGif} /> */}
              <h4
                className={headerClass}
                style={{
                  fontSize: "22px",
                  ...s.cardHeader,
                  fontFamily: "Gilroy-semibold",
                }}
              >
                {header}
              </h4>
            </div>
          </Col>
          <Col xs={12}>
            <p
              className={descriptionClass}
              style={{ marginTop: "28px", ...s.card2Descr }}
              // style={{ maxWidth: "82%" }}
            >
              {description}
            </p>
          </Col>
        </Row>
      </div>
    </Col>
  );
}

function ProsModule2() {
  const { s, toggleTheme } = useTheme();

  const { lang, changeLang, t } = useLang();
  return (
    <Row xs={1} lg={3} className="g-4 mt-2 mt-lg-4 align-items-stretch">
      <Pros2Card
        header={t("prosCards2Header1")}
        description={t("prosCards2Descr1")}
        picSrc={"/img/panelIconDark.png"}
      >
        <svg
          className="panel-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 42"
          fill="none"
        >
          <path
            d="M2.4 0H45.6C46.9255 0 48 1.04468 48 2.33333V39.6667C48 40.9554 46.9255 42 45.6 42H2.4C1.07453 42 0 40.9554 0 39.6667V2.33333C0 1.04468 1.07453 0 2.4 0ZM4.8 4.66667V37.3333H43.2V4.66667H4.8ZM16.0004 21L9.21221 14.4003L12.6063 11.1005L22.7887 21L12.6063 30.8994L9.21221 27.5996L16.0004 21Z"
            fill={s.cardBlinkColor}
            width="28px"
          />
          <path
            className="panel-blue-rect"
            d="M38.4 28H24V32.6667H38.4V28Z"
            fill="#23C1FF"
          />
        </svg>
      </Pros2Card>
      <Pros2Card
        header={t("prosCards2Header2")}
        description={t("prosCards2Descr2")}
        picSrc={"/img/pros2ArrowsDark.png"}
      >
        <style>{`
        @keyframes arrowTopBlink {
            0% {
              fill: ${s.cardBlinkColor};
            }
            25% {
              fill: #23c1ff;
            }
            50% {
              fill: ${s.cardBlinkColor};
            }
            100% {
              fill: ${s.cardBlinkColor};
            }
          }

        @keyframes arrowBottomBlink {
            0% {
              fill: ${s.cardBlinkColor};
            }
            25% {
              fill: #23c1ff;
            }
            50% {
              fill: ${s.cardBlinkColor};
            }
            100% {
              fill: ${s.cardBlinkColor};
            }
          }`}</style>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <path
            className="arrow-animation-top"
            d="M28.5 4H18.5L22.5572 8.05719L18.2239 12.3905L20.1095 14.2761L24.4428 9.94281L28.5 14V4Z"
            fill={s.cardBlinkColor}
          />
          <path
            className="arrow-animation-bottom"
            d="M4.5 28H14.5L10.4428 23.9428L14.7761 19.6095L12.8905 17.7239L8.55719 22.0572L4.5 18V28Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      </Pros2Card>
      <Pros2Card
        header={t("prosCards2Header3")}
        description={t("prosCards2Descr3")}
        picSrc={"/img/panelIconDark.png"}
      >
        <style>{`
        @keyframes mainColor {
  0%,
  25% {
    fill: ${s.cardBlinkColor};
  }
  50% {
    fill: #23c1ff;
  }
  75%,
  100% {
    fill: ${s.cardBlinkColor};
  }
}

@keyframes protrusionColor {
  0% {
    fill: ${s.cardBlinkColor};
  }
  25% {
    fill: #23c1ff;
  }
  75% {
    fill: #23c1ff;
  }
  100% {
    fill: ${s.cardBlinkColor};
  }
}`}</style>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <path
            className="cloud-main"
            d="M16.4992 2.66626C21.6539 2.66626 25.8325 6.84494 25.8325 11.9996C25.8325 12.1509 25.8289 12.3014 25.8219 12.451C28.9345 13.5463 31.1659 16.5124 31.1659 19.9996C31.1659 24.4179 27.5841 27.9996 23.1659 27.9996H9.83252C5.41424 27.9996 1.83252 24.4179 1.83252 19.9996C1.83252 16.5124 4.0638 13.5463 7.17657 12.451C7.16945 12.3014 7.16585 12.1509 7.16585 11.9996C7.16585 6.84494 11.3445 2.66626 16.4992 2.66626ZM16.4992 5.33293C12.8173 5.33293 9.83252 8.3177 9.83252 11.9996C9.83252 12.1082 9.83509 12.2164 9.84023 12.3242L9.93468 14.3075L8.06163 14.9665C5.94505 15.7112 4.49919 17.7181 4.49919 19.9996C4.49919 22.9451 6.887 25.3329 9.83252 25.3329H23.1659C26.1113 25.3329 28.4992 22.9451 28.4992 19.9996C28.4992 17.0529 26.1125 14.6663 23.1659 14.6663C20.8099 14.6663 18.8108 16.1939 18.1048 18.3125L15.5744 17.4691C16.6332 14.2909 19.6325 11.9996 23.1659 11.9996C23.1659 8.3177 20.1811 5.33293 16.4992 5.33293Z"
          />

          <path
            className="cloud-protrusion"
            d="M23.1659 11.9996C19.6325 11.9996 16.6332 14.2909 15.5744 17.4691L18.1048 18.3125C18.8108 16.1939 20.8099 14.6663 23.1659 14.6663"
          />
        </svg>
      </Pros2Card>
    </Row>
  );
}

function GuideCard({
  style,
  header,
  src,
  bg = "",
  bgColor = "",
  border,
  color,
}) {
  const guideBg = bgColor ? { backgroundColor: bgColor } : { background: bg };
  style === 1 ? (guideBg.paddingBottom = "6px") : (guideBg.paddingTop = "20px");
  guideBg.border = border;
  if (color) {
    guideBg.color = color;
  }

  return (
    <Col>
      <div className={styles.guideCard} style={guideBg}>
        {style === 1 ? (
          <>
            <div className={styles.phoneMockup}>
              {/* <video
                autoPlay
                loop
                muted
                playsInline
                className={styles.guideVideo}
              >
                <source src={src} type="video/mp4" />
                video
              </video> */}
              <img
                draggable="false"
                src={src}
                alt="GIF"
                className={styles.guideVideo}
              />
            </div>
            <p className="mt-auto">{header}</p>
          </>
        ) : (
          <>
            <p>{header}</p>
            <div className={styles.phoneMockup2}>
              {/* <video
                autoPlay
                loop
                muted
                playsInline
                className={styles.guideVideo2}
              >
                <source src={src} type="video/mp4" />
                video
              </video> */}
              <img
                draggable="false"
                src={src}
                alt="GIF"
                className={styles.guideVideo2}
              />
            </div>
          </>
        )}
      </div>
    </Col>
  );
}

function GuideModule() {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();
  return (
    <Row xs={1} md={2} xl={4} className="g-4 mt-2 mt-lg-4 align-items-stretch">
      <GuideCard
        header={t("guideHeader1")}
        style={1}
        bg={"linear-gradient(to right, #01B7FE 0%, #00A6E7 100%)"}
        src={"/img/start.gif"}
        border={"0"}
      />
      <GuideCard
        header={t("guideHeader2")}
        src={"/img/balance.gif"}
        border={s.guideCardBorder}
        bgColor={s.guideCard2Bg}
        color={s.guideCardTextColor}
      />
      <GuideCard
        header={t("guideHeader3")}
        style={1}
        bgColor={"#34383D"}
        src={"/img/server.gif"}
        border={"0"}
      />
      <Col>
        <div
          className={styles.guideCard}
          style={{
            textAlign: "center",
            paddingTop: "80px",
            backgroundColor: s.guideCard2Bg,
            color: s.guideCardTextColor,
            border: s.guideCardBorder,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="97"
            height="96"
            viewBox="0 0 97 96"
            fill="none"
          >
            <ellipse cx="49" cy="47.5" rx="28" ry="24.5" fill="#F8F8F8" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.0442 22.5446C29.5589 16.0299 38.5589 12.0005 48.5 12.0005C58.4411 12.0005 67.4411 16.0299 73.9558 22.5446C80.4706 29.0594 84.5 38.0594 84.5 48.0005C84.5 57.9416 80.4706 66.9416 73.9558 73.4563C67.4411 79.9711 58.4411 84.0005 48.5 84.0005C38.5589 84.0005 29.5589 79.9711 23.0442 73.4563C16.5294 66.9416 12.5 57.9416 12.5 48.0005C12.5 38.0594 16.5294 29.0594 23.0442 22.5446ZM48.7296 37.1235C45.1471 38.6449 37.9871 41.7939 27.2498 46.5703C25.5062 47.2782 24.5928 47.9708 24.5097 48.648C24.3691 49.7925 25.7728 50.2431 27.6843 50.8568C27.9443 50.9403 28.2137 51.0268 28.4899 51.1185C30.3705 51.7426 32.9003 52.4728 34.2154 52.5018C35.4083 52.5281 36.7397 52.026 38.2097 50.9954C48.242 44.081 53.4207 40.5861 53.7458 40.5108C53.9752 40.4576 54.293 40.3908 54.5084 40.5862C54.7238 40.7817 54.7026 41.1518 54.6798 41.2511C54.5407 41.8564 49.0307 47.0867 46.1792 49.7934C45.2903 50.6372 44.6598 51.2357 44.5309 51.3724C44.2421 51.6786 43.9478 51.9683 43.665 52.2467C41.9179 53.9663 40.6077 55.2559 43.7375 57.3617C45.2416 58.3737 46.4452 59.2106 47.6459 60.0454C48.9572 60.9572 50.2651 61.8666 51.9573 62.9992C52.3884 63.2878 52.8002 63.5875 53.2012 63.8794C54.7273 64.9902 56.0983 65.9881 57.7921 65.829C58.7763 65.7365 59.7929 64.7916 60.3092 61.9734C61.5294 55.3133 63.9279 40.8827 64.4822 34.9362C64.5307 34.4152 64.4697 33.7485 64.4206 33.4558C64.3715 33.1631 64.269 32.7461 63.8964 32.4374C63.4551 32.0717 62.7738 31.9946 62.4691 31.9999C61.0838 32.025 58.9583 32.7796 48.7296 37.1235Z"
              fill="#23C1FF"
            />
          </svg>
          <p className="mt-3">
            {t("guideHeader4_1")}
            <br />
            {t("guideHeader4_2")}
          </p>
          <a href="https://t.me/qwins_robot">
            <button className={styles.telegramButton}>Перейти</button>
          </a>
        </div>
      </Col>
    </Row>
  );
}

function MainBanner({
  header1,
  header2,
  description1,
  description2,
  description3,
  btnText,
  isXs,
  isSm,
  isXl,
  isLg,
  setCurPage,
}) {
  const descriptionClass = `${styles.mainBannerDescr} mt-3 mt-lg-4`;
  const btnClass = `${styles.mainBannerBtn} mt-3 mt-lg-5`;

  return (
    // Обернули баннер в контейнер с дополнительным классом для relative positioning и overflow
    <div
      className={`${styles.mainBannerWrapper} d-flex flex-column justify-content-center align-items-center pb-3 pb-lg-5 pt-3 pt-lg-4`}
    >
      {/* Левый декоративный элемент */}
      {(isLg || isXl) && (
        <>
          {/* <img
            src="/img/bannerArrowsLeft.png"
            alt="Декоративная линия слева"
            className={styles.leftDecor}
          /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="370"
            height="426"
            viewBox="0 0 370 426"
            fill="none"
            className={styles.leftDecor}
          >
            <path
              d="M314.998 47.122L-33.4931 -44M301.219 100.069L-45.8065 70.9941M296.806 156.132L-97 189.617M287.71 216.242L-89.1953 315.129M323.433 260.373L-65.0271 456.5M354.373 309.217L176.651 430.093M368.973 371.893L241.084 495.215"
              stroke="url(#paint0_linear_3315_437)"
              strokeWidth="2"
            />
            <defs>
              <linearGradient
                id="paint0_linear_3315_437"
                x1="49.3589"
                y1="189.79"
                x2="296.859"
                y2="170.29"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" stopOpacity="0.44" />
                <stop offset="1" stopColor="#ABBED3" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
          {/* <img
            src="/img/bannerArrowsRight.png"
            alt="Декоративная линия справа"
            className={styles.rightDecor}
          /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="426"
            viewBox="0 0 375 426"
            fill="none"
            className={styles.rightDecor}
          >
            <path
              d="M54.9749 47.122L403.466 -44M68.7538 100.069L415.779 70.9941M73.1669 156.132L466.973 189.617M82.263 216.242L459.168 315.129M46.5396 260.373L435 456.5M15.5997 309.217L193.322 430.093M1.00006 371.893L128.889 495.215"
              stroke="url(#paint0_linear_3315_436)"
              strokeWidth="2"
            />
            <defs>
              <linearGradient
                id="paint0_linear_3315_436"
                x1="320.614"
                y1="189.79"
                x2="73.1141"
                y2="170.29"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" stopOpacity="0.44" />
                <stop offset="1" stopColor="#B2C4D6" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </>
      )}

      <Row className="w-100">
        <Col>
          {isXs || isSm ? (
            <>
              <h4 className={`${styles.mainBannerHeader} mt-lg-3`}>
                {[header1, header2].join(" ")}
              </h4>
              <p className={descriptionClass}>
                {[description1, description2, description3].join(" ")}
              </p>
            </>
          ) : (
            <>
              <h4 className={`${styles.mainBannerHeader} mt-lg-3`}>
                {header1}
                <br />
                {header2}
              </h4>
              <p className={descriptionClass}>
                {description1}
                <br />
                {description2}
                <br />
                {description3}
              </p>
            </>
          )}
          <button
            className={btnClass}
            onClick={() => setCurPage("virtualServers")}
          >
            {btnText}
          </button>
        </Col>
      </Row>
    </div>
  );
}

// function MinorHeader({ header, description1, description2, isXs, isSm }) {
//   const headerClass = `${styles.minorHeader} mt-5`;
//   const { s, toggleTheme } = useTheme();

//   const descriptionClass = `${styles.minorDescr} mt-3 mt-lg-4`;
//   return (
//     <>
//       <h4 className={headerClass} style={s.minorHeader}>
//         {header}
//       </h4>

//       <p className={descriptionClass} style={s.minorDescr}>
//         {isXs || isSm ? (
//           [description1, description2].join("")
//         ) : (
//           <>
//             {description1}
//             {description2 && (
//               <>
//                 <br />
//                 {description2}
//               </>
//             )}
//           </>
//         )}
//       </p>
//     </>
//   );
// }

// function FDCard({ header, description, picSrc }) {
//   const descriptionClass = `${styles.cardDescr}`;
//   const headerClass = `${styles.cardHeader} m-0`;
//   const divClass = `${styles.card} h-100 ${styles.FDCardStructure}`;

//   return (
//     <Col>
//       <div className={divClass}>
//         <Row className="d-flex align-items-center">
//           <Col xs="auto">
//             {/* <img src={picSrc} alt="IMG" className={styles.prosSmallGif} /> */}
// <div className="panel-container">
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="28"
//     height="28"
//     viewBox="0 0 28 28"
//     fill="none"
//   >
//     <mask
//       id="mask0_3315_555"
//       style={{ maskType: "luminance" }}
//       maskUnits="userSpaceOnUse"
//       x="0"
//       y="0"
//       width="28"
//       height="26"
//     >
//       <path d="M28 0H0V25.4057H28V0Z" fill="white" />
//     </mask>
//     <g mask="url(#mask0_3315_555)">
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M7.18359 22.1346C9.7484 24.2181 12.7113 25.4055 15.8712 25.4055C20.5702 25.4055 24.8359 22.7719 28.0014 18.4822C26.6649 16.6716 25.1328 15.1549 23.453 14.0083L20.7559 15.3547C21.3356 16.2565 21.6732 17.33 21.6732 18.4822C21.6732 21.6829 19.0761 24.2772 15.8712 24.2772C13.381 24.2772 11.258 22.71 10.4349 20.5095L7.18359 22.1331V22.1346ZM13.8748 18.7931C13.9395 19.2138 14.1365 19.605 14.4418 19.9102C14.8202 20.2887 15.3351 20.5011 15.8712 20.4997C16.9868 20.4997 17.8915 19.5964 17.8915 18.4822C17.8915 17.9349 17.6734 17.4383 17.3189 17.0739L13.8762 18.7931H13.8748Z"
//         fill="#2BAD72"
//       />
//       <path
//         d="M7.91847 18.4374L27.5771 8.98725L23.2565 0L21.0251 7.94195L18.3436 2.36221L16.1108 10.3041L13.4293 4.72437L11.1966 12.6663L8.515 7.08652L6.28226 15.0285L3.60076 9.44873L0.000488281 22.2444L4.91478 19.8823L7.91847 18.4388V18.4374Z"
//         fill="#2BAD72"
//       />
//     </g>
//   </svg>
// </div>
//           </Col>
//           <Col>
//             <h4 className={headerClass} style={{ fontSize: "18px" }}>
//               {header}
//             </h4>
//             <p className="m-0" style={{ color: "#A7AAAF", fontSize: "16px" }}>
//               Отзыв клиента ·{" "}
//               <a href="#" style={{ textDecoration: "none", color: "#23C1FF" }}>
//                 lolz.live
//               </a>
//             </p>
//           </Col>
//         </Row>
//         <Row>
//           <Col xs={12}>
//             <p
//               className={descriptionClass}
//               style={{ color: "#fff", marginTop: "29px" }}
//             >
//               {description}
//             </p>
//           </Col>
//         </Row>
//       </div>
//     </Col>
//   );
// }

// function FDModule() {
//   return (
//     <Row xs={1} lg={3} className="g-4 mt-2 mt-lg-4 align-items-stretch">
//       <FDCard
//         header="Рассказчик"
//         description="С данным селлером работаем уже не первый раз, всё четко и быстро, доволен товаром, получил за отзыв +rep"
//         picSrc="/img/lolzIcon.png"
//       />
//       <FDCard
//         header="brellan"
//         description="Пользовался услугами данного селлера нераз на других проектах, все всегда проходило гладко и быстро. Одним словом - Получил за отзыв"
//         picSrc="/img/lolzIcon.png"
//       />
//       <FDCard
//         header="caspSOFT"
//         description="Дедик идеально выполнял свою работу решил продлевать на месяц немного не хватило чел сделал скидку советую"
//         picSrc="/img/lolzIcon.png"
//       />
//     </Row>
//   );
// }

const carouselStyles = `
  .carousel-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding: 0 0.5px;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
  gap: 25px;
}

.carousel-slide {
  flex: 0 0 calc(100% / 3 - 25px * 2 / 3); /* Точный расчет с учетом gap */
  box-sizing: border-box;
}
  
  @media (max-width: 992px) {
    .carousel-slide {
      flex: 0 0 100%;
    }
  }
  
  .carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  z-index: 10;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
}

/* Левая стрелка полностью слева от контейнера */
.carousel-arrow--left {
  left: -20px; /* Половина стрелки снаружи */
}

.carousel-arrow--right {
  right: -20px; /* Половина стрелки снаружи */
}
  `;
function FDCard({ header, description, picSrc }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  const descriptionClass = `${styles.cardDescr}`;
  const headerClass = `${styles.cardHeader} m-0`;
  const divClass = `${styles.card} h-100 ${styles.FDCardStructure}`;

  return (
    <div className={divClass} style={s.cardBg}>
      <Row className="d-flex align-items-center">
        <Col xs="auto">
          <div className="panel-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask
                id="mask0_3315_555"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="28"
                height="26"
              >
                <path d="M28 0H0V25.4057H28V0Z" fill="white" />
              </mask>
              <g mask="url(#mask0_3315_555)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.18359 22.1346C9.7484 24.2181 12.7113 25.4055 15.8712 25.4055C20.5702 25.4055 24.8359 22.7719 28.0014 18.4822C26.6649 16.6716 25.1328 15.1549 23.453 14.0083L20.7559 15.3547C21.3356 16.2565 21.6732 17.33 21.6732 18.4822C21.6732 21.6829 19.0761 24.2772 15.8712 24.2772C13.381 24.2772 11.258 22.71 10.4349 20.5095L7.18359 22.1331V22.1346ZM13.8748 18.7931C13.9395 19.2138 14.1365 19.605 14.4418 19.9102C14.8202 20.2887 15.3351 20.5011 15.8712 20.4997C16.9868 20.4997 17.8915 19.5964 17.8915 18.4822C17.8915 17.9349 17.6734 17.4383 17.3189 17.0739L13.8762 18.7931H13.8748Z"
                  fill="#2BAD72"
                />
                <path
                  d="M7.91847 18.4374L27.5771 8.98725L23.2565 0L21.0251 7.94195L18.3436 2.36221L16.1108 10.3041L13.4293 4.72437L11.1966 12.6663L8.515 7.08652L6.28226 15.0285L3.60076 9.44873L0.000488281 22.2444L4.91478 19.8823L7.91847 18.4388V18.4374Z"
                  fill="#2BAD72"
                />
              </g>
            </svg>
          </div>
        </Col>
        <Col>
          <h4
            className={headerClass}
            style={{
              fontSize: "18px",
              ...s.cardHeader,
              fontFamily: "Gilroy-semibold",
            }}
          >
            {header}
          </h4>
          <p
            className="m-0"
            style={{ color: s.fdPlaceholder, fontSize: "16px" }}
          >
            {t("fdPlaceholder")}
            <a style={{ textDecoration: "none", color: "#23C1FF" }}>
              lolz.live
            </a>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <p
            className={descriptionClass}
            style={{ color: s.fdDescr, marginTop: "29px" }}
          >
            {description}
          </p>
        </Col>
      </Row>
    </div>
  );
}

function FDModule() {
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("fdHeader1"),
      description: t("fdDescr1"),
      picSrc: "/img/lolzIcon.png",
    },
    {
      header: t("fdHeader2"),
      description: t("fdDescr2"),
      picSrc: "/img/lolzIcon.png",
    },
    {
      header: t("fdHeader3"),
      description: t("fdDescr3"),
      picSrc: "/img/lolzIcon.png",
    },
    {
      header: t("fdHeader4"),
      description: t("fdDescr4"),
      picSrc: "/img/lolzIcon.png",
    },
    {
      header: t("fdHeader5"),
      description: t("fdDescr5"),
      picSrc: "/img/lolzIcon.png",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = window.innerWidth <= 992; // Определяем мобильный вид
  const visibleCards = isMobile ? 1 : 3; // Динамическое количество карточек

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 <= cards.length - visibleCards ? prevIndex + 1 : 0
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 >= 0 ? prevIndex - 1 : cards.length - visibleCards
    );
  };

  const getTransformValue = () => {
    if (window.innerWidth <= 992) {
      return `translateX(calc(-${currentIndex} * (100% + 25px)))`; // Полный сдвиг на мобильных
    }
    return `translateX(calc(-${currentIndex} * (100% + 25px) / 3))`; // Для десктопа
  };

  return (
    <>
      <style>{carouselStyles}</style>
      <div
        style={{ position: "relative", width: "100%" }}
        className="mt-4 mt-lg-5"
      >
        <div className="carousel-container">
          <div
            className="carousel-track"
            style={{
              transform: getTransformValue(),
            }}
          >
            {cards.map((card, index) => (
              <div key={index} className="carousel-slide">
                <FDCard {...card} />
              </div>
            ))}
          </div>
        </div>

        {/* Стрелки остаются без изменений */}
        {currentIndex !== 0 && (
          <button
            className="carousel-arrow carousel-arrow--left"
            onClick={prevSlide}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              className={styles.arrowIconHover}
            >
              <circle cx="20" cy="20" r="20" fill="#232323" />
              <path
                d="M17.4374 20.0009L24.0371 13.4012L22.1515 11.5156L13.6662 20.0009L22.1515 28.4861L24.0371 26.6005L17.4374 20.0009Z"
                fill="#F8F8F8"
              />
            </svg>
          </button>
        )}
        {((isMobile && currentIndex !== 4) ||
          (!isMobile && currentIndex !== 2)) && (
          <button
            className="carousel-arrow carousel-arrow--right"
            onClick={nextSlide}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              className={styles.arrowIconHover}
            >
              <circle cx="20" cy="20" r="20" fill="#232323" />
              <path
                d="M22.5626 20.0009L15.9629 13.4012L17.8485 11.5156L26.3338 20.0009L17.8485 28.4861L15.9629 26.6005L22.5626 20.0009Z"
                fill="#F8F8F8"
              />
            </svg>
          </button>
        )}
      </div>
    </>
  );
}
function QuestionsModule() {
  const [openedCard, setOpenedCard] = useState(null);
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("qHeader1"),
      isOpened: true,
      description: t("qDescr1"),
      key: 0,
    },
    {
      header: t("qHeader2"),
      isOpened: true,
      description: t("qDescr2"),
      key: 1,
    },
    {
      header: t("qHeader3"),
      isOpened: true,
      description: t("qDescr3"),
      key: 2,
    },
    {
      header: t("qHeader4"),
      isOpened: true,
      description: t("qDescr4"),
      key: 3,
    },
  ];
  return (
    <Row className="mt-2  gx-3 gy-3">
      <Col xs={12} md={12} lg={6}>
        <Row xs={1} className="gy-2">
          {cards.map((el) => (
            <Col>
              <QuestionCard
                {...el}
                isOpened={el.key === openedCard}
                setOpened={setOpenedCard}
                index={el.key}
                key={el.key}
              />
            </Col>
          ))}
        </Row>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader1")}
          description={t("qCardDescr1")}
          linkText={t("qCardLink1")}
          link={"https://wiki.qwins.co/"}
        />
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader2")}
          description={t("qCardDescr2")}
          linkText={t("qCardLink2")}
          link={"https://t.me/qwinshelp"}
        />
      </Col>
    </Row>
  );
}
export default function HomePage({ windowSize, isLightTheme, setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <>
      <MainBanner
        header1={t("mainBannerHeader1")}
        header2={t("mainBannerHeader2")}
        description1={t("mainBannerDescr1")}
        description2={t("mainBannerDescr2")}
        description3={t("mainBannerDescr3")}
        btnText={t("mainBannerBtn")}
        {...windowSize}
        setCurPage={setCurPage}
      />
      <ProsModule />
      <MinorHeader
        header={t("minorHeader1")}
        description1={t("minorHeader1Descr1")}
        description2={t("minorHeader1Descr2")}
        isXs={windowSize.isXs}
        isSm={windowSize.isSm}
      />
      <ProsModule2 />
      <MinorHeader
        header={t("minorHeader2")}
        description1={t("minorHeader2Descr1")}
      />

      <GuideModule />

      <MinorHeader
        header={t("minorHeader3")}
        description1={t("minorHeader3Descr1")}
      />
      <FDModule {...windowSize} />
      <div style={{ textAlign: "left" }}>
        <h4
          className={`${styles.minorHeader} mt-5 mb-0`}
          style={{ ...s.minorHeader, fontFamily: "Gilroy-semibold" }}
        >
          {t("qMinorHeader")}
        </h4>
      </div>

      <QuestionsModule />
    </>
  );
}
